export const weeklyTimings = {
  hours: [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23"
  ],
  days: [
    {
      nameOfDay: "lng_monday",
      hours: [
        {
          nameOfHour: "00",
          value: 0
        },
        {
          nameOfHour: "01",
          value: 0
        },
        {
          nameOfHour: "02",
          value: 0
        },
        {
          nameOfHour: "03",
          value: 0
        },
        {
          nameOfHour: "04",
          value: 0
        },
        {
          nameOfHour: "05",
          value: 0
        },
        {
          nameOfHour: "06",
          value: 0
        },
        {
          nameOfHour: "07",
          value: 0
        },
        {
          nameOfHour: "08",
          value: 0
        },
        {
          nameOfHour: "09",
          value: 0
        },
        {
          nameOfHour: "10",
          value: 0
        },
        {
          nameOfHour: "11",
          value: 0
        },
        {
          nameOfHour: "12",
          value: 0
        },
        {
          nameOfHour: "13",
          value: 0
        },
        {
          nameOfHour: "14",
          value: 0
        },
        {
          nameOfHour: "15",
          value: 0
        },
        {
          nameOfHour: "16",
          value: 0
        },
        {
          nameOfHour: "17",
          value: 0
        },
        {
          nameOfHour: "18",
          value: 0
        },
        {
          nameOfHour: "19",
          value: 0
        },
        {
          nameOfHour: "20",
          value: 0
        },
        {
          nameOfHour: "21",
          value: 0
        },
        {
          nameOfHour: "22",
          value: 0
        },
        {
          nameOfHour: "23",
          value: 0
        }
      ]
    },
    {
      nameOfDay: "lng_tuesday",
      hours: [
        {
          nameOfHour: "00",
          value: 0
        },
        {
          nameOfHour: "01",
          value: 0
        },
        {
          nameOfHour: "02",
          value: 0
        },
        {
          nameOfHour: "03",
          value: 0
        },
        {
          nameOfHour: "04",
          value: 0
        },
        {
          nameOfHour: "05",
          value: 0
        },
        {
          nameOfHour: "06",
          value: 0
        },
        {
          nameOfHour: "07",
          value: 0
        },
        {
          nameOfHour: "08",
          value: 0
        },
        {
          nameOfHour: "09",
          value: 0
        },
        {
          nameOfHour: "10",
          value: 0
        },
        {
          nameOfHour: "11",
          value: 0
        },
        {
          nameOfHour: "12",
          value: 0
        },
        {
          nameOfHour: "13",
          value: 0
        },
        {
          nameOfHour: "14",
          value: 0
        },
        {
          nameOfHour: "15",
          value: 0
        },
        {
          nameOfHour: "16",
          value: 0
        },
        {
          nameOfHour: "17",
          value: 0
        },
        {
          nameOfHour: "18",
          value: 0
        },
        {
          nameOfHour: "19",
          value: 0
        },
        {
          nameOfHour: "20",
          value: 0
        },
        {
          nameOfHour: "21",
          value: 0
        },
        {
          nameOfHour: "22",
          value: 0
        },
        {
          nameOfHour: "23",
          value: 0
        }
      ]
    },
    {
      nameOfDay: "lng_wednesday",
      hours: [
        {
          nameOfHour: "00",
          value: 0
        },
        {
          nameOfHour: "01",
          value: 0
        },
        {
          nameOfHour: "02",
          value: 0
        },
        {
          nameOfHour: "03",
          value: 0
        },
        {
          nameOfHour: "04",
          value: 0
        },
        {
          nameOfHour: "05",
          value: 0
        },
        {
          nameOfHour: "06",
          value: 0
        },
        {
          nameOfHour: "07",
          value: 0
        },
        {
          nameOfHour: "08",
          value: 0
        },
        {
          nameOfHour: "09",
          value: 0
        },
        {
          nameOfHour: "10",
          value: 0
        },
        {
          nameOfHour: "11",
          value: 0
        },
        {
          nameOfHour: "12",
          value: 0
        },
        {
          nameOfHour: "13",
          value: 0
        },
        {
          nameOfHour: "14",
          value: 0
        },
        {
          nameOfHour: "15",
          value: 0
        },
        {
          nameOfHour: "16",
          value: 0
        },
        {
          nameOfHour: "17",
          value: 0
        },
        {
          nameOfHour: "18",
          value: 0
        },
        {
          nameOfHour: "19",
          value: 0
        },
        {
          nameOfHour: "20",
          value: 0
        },
        {
          nameOfHour: "21",
          value: 0
        },
        {
          nameOfHour: "22",
          value: 0
        },
        {
          nameOfHour: "23",
          value: 0
        }
      ]
    },
    {
      nameOfDay: "lng_thursday",
      hours: [
        {
          nameOfHour: "00",
          value: 0
        },
        {
          nameOfHour: "01",
          value: 0
        },
        {
          nameOfHour: "02",
          value: 0
        },
        {
          nameOfHour: "03",
          value: 0
        },
        {
          nameOfHour: "04",
          value: 0
        },
        {
          nameOfHour: "05",
          value: 0
        },
        {
          nameOfHour: "06",
          value: 0
        },
        {
          nameOfHour: "07",
          value: 0
        },
        {
          nameOfHour: "08",
          value: 0
        },
        {
          nameOfHour: "09",
          value: 0
        },
        {
          nameOfHour: "10",
          value: 0
        },
        {
          nameOfHour: "11",
          value: 0
        },
        {
          nameOfHour: "12",
          value: 0
        },
        {
          nameOfHour: "13",
          value: 0
        },
        {
          nameOfHour: "14",
          value: 0
        },
        {
          nameOfHour: "15",
          value: 0
        },
        {
          nameOfHour: "16",
          value: 0
        },
        {
          nameOfHour: "17",
          value: 0
        },
        {
          nameOfHour: "18",
          value: 0
        },
        {
          nameOfHour: "19",
          value: 0
        },
        {
          nameOfHour: "20",
          value: 0
        },
        {
          nameOfHour: "21",
          value: 0
        },
        {
          nameOfHour: "22",
          value: 0
        },
        {
          nameOfHour: "23",
          value: 0
        }
      ]
    },
    {
      nameOfDay: "lng_friday",
      hours: [
        {
          nameOfHour: "00",
          value: 0
        },
        {
          nameOfHour: "01",
          value: 0
        },
        {
          nameOfHour: "02",
          value: 0
        },
        {
          nameOfHour: "03",
          value: 0
        },
        {
          nameOfHour: "04",
          value: 0
        },
        {
          nameOfHour: "05",
          value: 0
        },
        {
          nameOfHour: "06",
          value: 0
        },
        {
          nameOfHour: "07",
          value: 0
        },
        {
          nameOfHour: "08",
          value: 0
        },
        {
          nameOfHour: "09",
          value: 0
        },
        {
          nameOfHour: "10",
          value: 0
        },
        {
          nameOfHour: "11",
          value: 0
        },
        {
          nameOfHour: "12",
          value: 0
        },
        {
          nameOfHour: "13",
          value: 0
        },
        {
          nameOfHour: "14",
          value: 0
        },
        {
          nameOfHour: "15",
          value: 0
        },
        {
          nameOfHour: "16",
          value: 0
        },
        {
          nameOfHour: "17",
          value: 0
        },
        {
          nameOfHour: "18",
          value: 0
        },
        {
          nameOfHour: "19",
          value: 0
        },
        {
          nameOfHour: "20",
          value: 0
        },
        {
          nameOfHour: "21",
          value: 0
        },
        {
          nameOfHour: "22",
          value: 0
        },
        {
          nameOfHour: "23",
          value: 0
        }
      ]
    },
    {
      nameOfDay: "lng_saturday",
      hours: [
        {
          nameOfHour: "00",
          value: 0
        },
        {
          nameOfHour: "01",
          value: 0
        },
        {
          nameOfHour: "02",
          value: 0
        },
        {
          nameOfHour: "03",
          value: 0
        },
        {
          nameOfHour: "04",
          value: 0
        },
        {
          nameOfHour: "05",
          value: 0
        },
        {
          nameOfHour: "06",
          value: 0
        },
        {
          nameOfHour: "07",
          value: 0
        },
        {
          nameOfHour: "08",
          value: 0
        },
        {
          nameOfHour: "09",
          value: 0
        },
        {
          nameOfHour: "10",
          value: 0
        },
        {
          nameOfHour: "11",
          value: 0
        },
        {
          nameOfHour: "12",
          value: 0
        },
        {
          nameOfHour: "13",
          value: 0
        },
        {
          nameOfHour: "14",
          value: 0
        },
        {
          nameOfHour: "15",
          value: 0
        },
        {
          nameOfHour: "16",
          value: 0
        },
        {
          nameOfHour: "17",
          value: 0
        },
        {
          nameOfHour: "18",
          value: 0
        },
        {
          nameOfHour: "19",
          value: 0
        },
        {
          nameOfHour: "20",
          value: 0
        },
        {
          nameOfHour: "21",
          value: 0
        },
        {
          nameOfHour: "22",
          value: 0
        },
        {
          nameOfHour: "23",
          value: 0
        }
      ]
    },
    {
      nameOfDay: "lng_sunday",
      hours: [
        {
          nameOfHour: "00",
          value: 0
        },
        {
          nameOfHour: "01",
          value: 0
        },
        {
          nameOfHour: "02",
          value: 0
        },
        {
          nameOfHour: "03",
          value: 0
        },
        {
          nameOfHour: "04",
          value: 0
        },
        {
          nameOfHour: "05",
          value: 0
        },
        {
          nameOfHour: "06",
          value: 0
        },
        {
          nameOfHour: "07",
          value: 0
        },
        {
          nameOfHour: "08",
          value: 0
        },
        {
          nameOfHour: "09",
          value: 0
        },
        {
          nameOfHour: "10",
          value: 0
        },
        {
          nameOfHour: "11",
          value: 0
        },
        {
          nameOfHour: "12",
          value: 0
        },
        {
          nameOfHour: "13",
          value: 0
        },
        {
          nameOfHour: "14",
          value: 0
        },
        {
          nameOfHour: "15",
          value: 0
        },
        {
          nameOfHour: "16",
          value: 0
        },
        {
          nameOfHour: "17",
          value: 0
        },
        {
          nameOfHour: "18",
          value: 0
        },
        {
          nameOfHour: "19",
          value: 0
        },
        {
          nameOfHour: "20",
          value: 0
        },
        {
          nameOfHour: "21",
          value: 0
        },
        {
          nameOfHour: "22",
          value: 0
        },
        {
          nameOfHour: "23",
          value: 0
        }
      ]
    }
  ]
};

export const dhwTimings = {
  days: [
    "lng_monday",
    "lng_tuesday",
    "lng_wednesday",
    "lng_thursday",
    "lng_friday",
    "lng_saturday",
    "lng_sunday"
  ],
  hours: [
    {
      nameOfHour: "00.00-02.00",
      hours: [
        {
          nameOfDay: "lng_monday",
          value: 0
        },
        {
          nameOfDay: "lng_tuesday",
          value: 0
        },
        {
          nameOfDay: "lng_wednesday",
          value: 0
        },
        {
          nameOfDay: "lng_thursday",
          value: 0
        },
        {
          nameOfDay: "lng_friday",
          value: 0
        },
        {
          nameOfDay: "lng_saturday",
          value: 0
        },
        {
          nameOfDay: "lng_sunday",
          value: 0
        }
      ]
    },
    {
      nameOfHour: "02.00-04.00",
      hours: [
        {
          nameOfDay: "lng_monday",
          value: 0
        },
        {
          nameOfDay: "lng_tuesday",
          value: 0
        },
        {
          nameOfDay: "lng_wednesday",
          value: 0
        },
        {
          nameOfDay: "lng_thursday",
          value: 0
        },
        {
          nameOfDay: "lng_friday",
          value: 0
        },
        {
          nameOfDay: "lng_saturday",
          value: 0
        },
        {
          nameOfDay: "lng_sunday",
          value: 0
        }
      ]
    },
    {
      nameOfHour: "04.00-06.00",
      hours: [
        {
          nameOfDay: "lng_monday",
          value: 0
        },
        {
          nameOfDay: "lng_tuesday",
          value: 0
        },
        {
          nameOfDay: "lng_wednesday",
          value: 0
        },
        {
          nameOfDay: "lng_thursday",
          value: 0
        },
        {
          nameOfDay: "lng_friday",
          value: 0
        },
        {
          nameOfDay: "lng_saturday",
          value: 0
        },
        {
          nameOfDay: "lng_sunday",
          value: 0
        }
      ]
    },
    {
      nameOfHour: "06.00-08.00",
      hours: [
        {
          nameOfDay: "lng_monday",
          value: 0
        },
        {
          nameOfDay: "lng_tuesday",
          value: 0
        },
        {
          nameOfDay: "lng_wednesday",
          value: 0
        },
        {
          nameOfDay: "lng_thursday",
          value: 0
        },
        {
          nameOfDay: "lng_friday",
          value: 0
        },
        {
          nameOfDay: "lng_saturday",
          value: 0
        },
        {
          nameOfDay: "lng_sunday",
          value: 0
        }
      ]
    },
    {
      nameOfHour: "08.00-10.00",
      hours: [
        {
          nameOfDay: "lng_monday",
          value: 0
        },
        {
          nameOfDay: "lng_tuesday",
          value: 0
        },
        {
          nameOfDay: "lng_wednesday",
          value: 0
        },
        {
          nameOfDay: "lng_thursday",
          value: 0
        },
        {
          nameOfDay: "lng_friday",
          value: 0
        },
        {
          nameOfDay: "lng_saturday",
          value: 0
        },
        {
          nameOfDay: "lng_sunday",
          value: 0
        }
      ]
    },
    {
      nameOfHour: "10.00-12.00",
      hours: [
        {
          nameOfDay: "lng_monday",
          value: 0
        },
        {
          nameOfDay: "lng_tuesday",
          value: 0
        },
        {
          nameOfDay: "lng_wednesday",
          value: 0
        },
        {
          nameOfDay: "lng_thursday",
          value: 0
        },
        {
          nameOfDay: "lng_friday",
          value: 0
        },
        {
          nameOfDay: "lng_saturday",
          value: 0
        },
        {
          nameOfDay: "lng_sunday",
          value: 0
        }
      ]
    },
    {
      nameOfHour: "12.00-14.00",
      hours: [
        {
          nameOfDay: "lng_monday",
          value: 0
        },
        {
          nameOfDay: "lng_tuesday",
          value: 0
        },
        {
          nameOfDay: "lng_wednesday",
          value: 0
        },
        {
          nameOfDay: "lng_thursday",
          value: 0
        },
        {
          nameOfDay: "lng_friday",
          value: 0
        },
        {
          nameOfDay: "lng_saturday",
          value: 0
        },
        {
          nameOfDay: "lng_sunday",
          value: 0
        }
      ]
    },
    {
      nameOfHour: "14.00-16.00",
      hours: [
        {
          nameOfDay: "lng_monday",
          value: 0
        },
        {
          nameOfDay: "lng_tuesday",
          value: 0
        },
        {
          nameOfDay: "lng_wednesday",
          value: 0
        },
        {
          nameOfDay: "lng_thursday",
          value: 0
        },
        {
          nameOfDay: "lng_friday",
          value: 0
        },
        {
          nameOfDay: "lng_saturday",
          value: 0
        },
        {
          nameOfDay: "lng_sunday",
          value: 0
        }
      ]
    },
    {
      nameOfHour: "16.00-18.00",
      hours: [
        {
          nameOfDay: "lng_monday",
          value: 0
        },
        {
          nameOfDay: "lng_tuesday",
          value: 0
        },
        {
          nameOfDay: "lng_wednesday",
          value: 0
        },
        {
          nameOfDay: "lng_thursday",
          value: 0
        },
        {
          nameOfDay: "lng_friday",
          value: 0
        },
        {
          nameOfDay: "lng_saturday",
          value: 0
        },
        {
          nameOfDay: "lng_sunday",
          value: 0
        }
      ]
    },
    {
      nameOfHour: "18.00-20.00",
      hours: [
        {
          nameOfDay: "lng_monday",
          value: 0
        },
        {
          nameOfDay: "lng_tuesday",
          value: 0
        },
        {
          nameOfDay: "lng_wednesday",
          value: 0
        },
        {
          nameOfDay: "lng_thursday",
          value: 0
        },
        {
          nameOfDay: "lng_friday",
          value: 0
        },
        {
          nameOfDay: "lng_saturday",
          value: 0
        },
        {
          nameOfDay: "lng_sunday",
          value: 0
        }
      ]
    },
    {
      nameOfHour: "20.00-22.00",
      hours: [
        {
          nameOfDay: "lng_monday",
          value: 0
        },
        {
          nameOfDay: "lng_tuesday",
          value: 0
        },
        {
          nameOfDay: "lng_wednesday",
          value: 0
        },
        {
          nameOfDay: "lng_thursday",
          value: 0
        },
        {
          nameOfDay: "lng_friday",
          value: 0
        },
        {
          nameOfDay: "lng_saturday",
          value: 0
        },
        {
          nameOfDay: "lng_sunday",
          value: 0
        }
      ]
    },
    {
      nameOfHour: "22.00-24.00",
      hours: [
        {
          nameOfDay: "lng_monday",
          value: 0
        },
        {
          nameOfDay: "lng_tuesday",
          value: 0
        },
        {
          nameOfDay: "lng_wednesday",
          value: 0
        },
        {
          nameOfDay: "lng_thursday",
          value: 0
        },
        {
          nameOfDay: "lng_friday",
          value: 0
        },
        {
          nameOfDay: "lng_saturday",
          value: 0
        },
        {
          nameOfDay: "lng_sunday",
          value: 0
        }
      ]
    }
  ]
};
